import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import {
  LogOutIcon,
  // UrbanCompassLogo,
  UrbanCompassLogoBlack,
} from '../../../icons';
import { useAuth } from '../../../hooks/useAuth';
import { useLanguage } from '../../../hooks/useLanguageSwitch';
import DropDown from '../../../components/uielements/dropDown';
import { getLanguageLabel, languageOptions } from '../../pages/chatBot/constant';
import { IntlMessages } from '../../../helper/langHelper';
import {
  clearCache,
  clearCacheOverlaysScreenshots,
  clearSummaryCache,
} from '../../../helper/cacheHelper';
import { clearItem } from '../../../helper/localStorageHelper';
import { Plus } from 'lucide-react';
import { key } from 'styled-theme';
import ConfirmationModal from '../../../components/uielements/modal/confirmationModal';
import CityOfOretonLogo from '../../../settings/moretonBayLogo';
import useOverlayStore from '../../../store/overlayStore';
import useShapeStore from '../../../store/shapeStore';
import { useQueryClient } from '@tanstack/react-query';
import Cache from '../../../helper/globalCacheHelper';
import EnquiryModal from './modal/enquiryModal';

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isPromptScreen =
    location.pathname === '/promptSelect' || location.pathname === '/addressSearch';
  const isQuestionScreen = location.pathname === '/generateQuestion';
  const isInitialPage = location.pathname === '/';
  // const isApplicationPage = location.pathname === '/applications';

  const isSpecificRoute =
    location.pathname === '/reportReview' ||
    location?.pathname?.includes('application') ||
    location.pathname === '/preLodgementReport' ||
    location.pathname === '/documentUpload' ||
    location.pathname === '/analytics' ||
    location.pathname === '/analyticsDetails' ||
    location.pathname === '/';

  const { logout } = useAuth();
  const languageChanged = useLanguage();
  const [confirmation, setConfirmation] = useState(false);
  const { clearOverlayData } = useOverlayStore();
  const { resetAll } = useShapeStore();
  const queryClient = useQueryClient();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleLogout = () => {
    queryClient.clear();
    queryClient.removeQueries();
    clearCache();
    clearSummaryCache();
    Cache.clearAllCaches();
    clearCacheOverlaysScreenshots();
    clearItem('applicationId');
    clearItem('procedure');
    clearItem('screenshotId');
    clearItem('image-store');
    clearItem('procedurePermit');
    clearOverlayData();
    resetAll();
    logout();
    navigate('/', { replace: true });
  };

  const handleAddressSearch = () => {
    clearCacheOverlaysScreenshots();
    setIsModalOpen(true);
  };

  const handleConfirmation = () => {
    setConfirmation(false);
    clearOverlayData();
    clearCacheOverlaysScreenshots();
    resetAll();
    // navigate('/applications', { replace: true });
    navigate('/', { replace: true });
  };

  const handleSetSelectedLangIntoLocalStorage = (lang) => {
    if (lang) {
      languageChanged.setLanguage(lang.value);
    }
  };

  return (
    <Nav
      isBackground={isPromptScreen}
      isQuestionScreen={isQuestionScreen}
      isSpecificRoute={isSpecificRoute}
    >
      <Logo>
        {/* {isInitialPage ? (
          <UrbanCompassLogo onClick={() => navigate('/')} />
        ) : (
          <UrbanCompassLogoBlack onClick={() => navigate('/')} />
        )} */}
        {/* {isInitialPage ? (
          <CityOfOretonLogo color={'#fff'} onClick={() => navigate('/')} />
        ) : ( */}
        <UrbanCompassLogoBlack color={'#000'} onClick={() => navigate('/')} />
        {/* )} */}
      </Logo>

      <div style={{ display: 'flex', gap: '10px' }}>
        {' '}
        {/* <CreateApplicationButton onClick={() => navigate('/analytics')}>
          Admin View
        </CreateApplicationButton> */}
        <CreateApplicationButton
          // onClick={
          //   isApplicationPage
          //     ? handleAddressSearch
          //     : isInitialPage
          //       ? () => navigate('/applications')
          //       : () => setConfirmation(true)
          // }

          onClick={isInitialPage ? handleAddressSearch : () => setConfirmation(true)}
          className="create_application_button"
        >
          {/* {isApplicationPage ? ( */}
          <>
            <Plus />
            <IntlMessages id="button.label.create" />
          </>
          {/* ) : (
            <IntlMessages id="button.label.dashboard" />
          )} */}
        </CreateApplicationButton>
        {/* {!isInitialPage && ( */}
        <DropDown
          options={languageOptions}
          selectedOption={handleSetSelectedLangIntoLocalStorage}
          label={getLanguageLabel(languageChanged?.selectedLang) || 'Choose Language'}
          width="180px"
        />
        {/* )} */}
        <LogoutButton onClick={handleLogout}>
          <LogOutIcon /> <IntlMessages id="button.logout" />
        </LogoutButton>
        <ConfirmationModal
          isModalOpen={confirmation}
          onClose={() => setConfirmation(false)}
          onConfirm={handleConfirmation}
          title={<IntlMessages id="confirmation.title" />}
          message={<IntlMessages id="confirmation.message" />}
          confirmText={<IntlMessages id="button.label.yes" />}
          cancelText={<IntlMessages id="button.label.cancel" />}
        />
        <EnquiryModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      </div>
    </Nav>
  );
};

export default Navbar;

// Styled Components
const Nav = styled.nav`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 120px;
  background: ${({ isBackground, isQuestionScreen, isSpecificRoute }) =>
    isBackground
      ? 'linear-gradient(to right, #ECEAF8 50%, transparent 50%)'
      : isQuestionScreen
        ? 'linear-gradient(to right, #ECEAF8 50%, transparent 50%)'
        : isSpecificRoute
          ? '#ECEAF8'
          : 'transparent'};
  z-index: 999;
`;

export const Logo = styled.div`
  cursor: pointer;
`;

const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 25px;
  font-size: 16px;
  border-radius: ${key('sizes.borderRadius.normal', '18px')};
  cursor: pointer;
  transition: all 0.3s ease;
  background: linear-gradient(90deg, #7b5cff, #60a5fa);
  color: white;
  border: 1px solid #eceaf8;

  &:hover {
    cursor: pointer;
    /* background: linear-gradient(90deg, #60a5fa, #7b5cff);
    transition: all 0.3s ease; */
  }
`;

export const CreateApplicationButton = styled(LogoutButton)`
  font-family: ${key('fonts.primary', 'JetBrains Mono Regular')};
`;
